import { render, staticRenderFns } from "./ProductCompareEdit.vue?vue&type=template&id=f690e840&"
import script from "./ProductCompareEdit.vue?vue&type=script&lang=js&"
export * from "./ProductCompareEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports